class RecommendationProductsController {

    constructor(breakpointsService, recommendationProductsService) {
        this.breakpointsService = breakpointsService;
        this.recommendationProductsService = recommendationProductsService;
    }

    $onInit() {
        this.getPlacements();
    }

    getPlacements() {
        const isInSmallFormat = this.breakpointsService.isInSmallFormat;
        const carouselSignedInMessage = this.message ? this.message : '';

        this.recommendationProductsService.getRecommendationPlacements(false, isInSmallFormat, carouselSignedInMessage)
            .then((placement) => {
                this.placement = {
                    message: placement.message,
                    Products: placement.Products,
                    placement_name: placement.placement_name,
                };
            });
    }
}

RecommendationProductsController.$inject = ['BreakpointsService', 'RecommendationProductsService'];

const recommendationProductsControllerComponentDefinition = {
    bindings: {
        message: '@?',
    },
    controller: RecommendationProductsController,
    template: require('./recommendation-products.component.html').trim(),
};

module.exports = {
    RecommendationProductsController,
    recommendationProductsControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/recommendation/recommendation-products.component.js